<script setup lang="ts">
import { Form, Head } from '@inertiajs/vue3'

import AuthBase from '@/layouts/AuthLayout.vue'
import { firstFormError } from '@/lib/forms'
import { newIdentityPasswordResetPath, signInPath } from '@/routes'
</script>

<template>
  <AuthBase
    title="Log in to your account"
    description="Enter your email and password below to log in"
  >
    <Head title="Log in" />

    <Form
      v-slot="{ errors, processing }"
      method="post"
      :action="signInPath()"
      :reset-on-success="['password']"
      class="flex flex-col gap-6"
    >
      <div class="grid gap-6">
        <UFormField
          label="Email address"
          name="email"
          :error="firstFormError(errors.email)"
          required
        >
          <UInput
            id="email"
            name="email"
            type="email"
            required
            autofocus
            :tabindex="1"
            autocomplete="email"
            placeholder="email@example.com"
            icon="i-lucide-mail"
            class="w-full"
          />
        </UFormField>

        <UFormField
          label="Password"
          name="password"
          :error="firstFormError(errors.password)"
          required
        >
          <template #hint>
            <ULink
              :to="newIdentityPasswordResetPath()"
              class="text-primary text-sm font-medium"
              :tabindex="5"
            >
              Forgot password?
            </ULink>
          </template>

          <UInput
            id="password"
            name="password"
            type="password"
            required
            :tabindex="2"
            autocomplete="current-password"
            placeholder="Password"
            icon="i-lucide-lock-keyhole"
            class="w-full"
          />
        </UFormField>

        <UButton
          type="submit"
          class="mt-4 w-full"
          :tabindex="4"
          :loading="processing"
          label="Log in"
          icon="i-lucide-log-in"
        />
      </div>
    </Form>
  </AuthBase>
</template>
